import {CommonClinicalSupportPdfDataProcessor} from '../export-care-plan-common-clinical-pdf-data';

export class VaccinationPdfDataProcessor extends CommonClinicalSupportPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.
}
